import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem, colors } from '../lib/global-styles';

import ReturnButton from './ReturnButton';
import { getFlashMessage } from '../store/selectors';
import FailStatusImg from '../images/Failure.png';
import SucessStatusImg from '../images/Check.png';
import flashMessageTypes from '../constants/flashMessageTypes';
import { doHideModal, doSetFlashMessage } from '../store/actions';

const FlashMessageWrapper = styled.div`
  display: flex;
  height: ${props => (props.mobile ? `100vh` : '')};
  padding: ${props => (props.mobile ? '' : `${rem(60)} 0`)};
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

const Title = styled.h2`
  font-size: ${rem(20)};
  font-weight: bold;
  letter-spacing: ${rem(0.23)};
  margin-top: ${rem(25)};
  line-height: ${rem(24)};
  max-width: ${rem(285)};
`;

const Text = styled.p`
  letter-spacing: ${rem(0.2)};
  line-height: ${rem(21)};
  padding: 0 ${rem(16)};
  margin-top: ${rem(18)};
  box-sizing: border-box;
  color: ${colors.darkGrey};
  max-width: ${rem(285)};
`;

class FlashMessage extends Component {
  onCloseButtonClick = () => {
    const { onHideModal, onSetFlashMessage } = this.props;

    onHideModal();
    onSetFlashMessage({ type: null, content: null });
  };

  getImage = () => {
    const { type } = this.props.flashMessage;

    if (type === flashMessageTypes.error) {
      return FailStatusImg;
    }
    return SucessStatusImg;
  };

  render() {
    const { type, content } = this.props.flashMessage;
    const { onCloseClick, hideReturnButton, modal } = this.props;

    return (
      <>
        {type ? (
          <FlashMessageWrapper>
            <img src={this.getImage()} alt={type} />
            <Title>{content.title}</Title>
            <Text>{content.text}</Text>
            {!hideReturnButton ? (
              <ReturnButton
                modal={modal}
                type={type}
                onCloseClick={onCloseClick || this.onCloseButtonClick}
              />
            ) : null}
          </FlashMessageWrapper>
        ) : null}
      </>
    );
  }
}

FlashMessage.propTypes = {
  type: PropTypes.string,
  content: PropTypes.object,
  flashMessage: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  flashMessage: getFlashMessage(state),
});

const mapDispatchToProps = dispatch => ({
  onHideModal: () => dispatch(doHideModal()),
  onSetFlashMessage: message => dispatch(doSetFlashMessage(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FlashMessage);
